import { commentSchema } from '@/models/commentSchema';
import { apiPath } from '@/redux/apiPath';
import { axiosInstanceNewAPI } from '@/services/api/utils/axiosInstance';
import { ThunkConfig } from '@/types/store';
import { validateDataUsingZodSchema } from '@/utils/validateDataUsingZodSchema';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Comment } from '@/types/models';
import { AddCommentProps } from '@/redux/comment/comment.types';
import { getError } from '@/utils/error-report/getError';
import { PROJECT_ID } from '@/constants';

export const addComment = createAsyncThunk<Comment | null, AddCommentProps, ThunkConfig>(
  'project/addComment',
  async ({ email, content, modelId, position }) => {
    try {
      const payload = {
        content,
        email,
        coordinates: { x: Math.trunc(position.x), y: Math.trunc(position.y) },
        visible: true,
      };
      const response = await axiosInstanceNewAPI.post<Comment>(
        apiPath.addComment(PROJECT_ID, modelId),
        payload,
      );

      const isDataValid = validateDataUsingZodSchema(response.data, commentSchema);

      return isDataValid ? response.data : null;
    } catch (error) {
      return Promise.reject(getError({ error }));
    }
  },
);
